import { FILTER_VARIANTS } from '../../constants';
import { FilterParamsCreator } from '../../types';
import { FilterStateValue } from '../../types/filters';

import { checkIsValidFilterStateValue } from './checkIsValidFilterStateValue';

export const prepareParamsCreator = (
  variant: FILTER_VARIANTS,
  callback: FilterParamsCreator
) => {
  return function (value: FilterStateValue) {
    if (checkIsValidFilterStateValue(variant, value)) {
      return callback(value);
    }
  };
};

export default prepareParamsCreator;
